module.exports = __webpack_public_path__ + "08_mustache_grey.d61a17e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/08_mustache_grey.png
// module id = aqes
// module chunks = 0